import { requestJson } from './apiClient'
const BASE_PATH = '/api/empresa'

const apiEmpresaService = {
  listEmpresas() {
    return requestJson({ method: 'GET', path: BASE_PATH })
  },
}

export default apiEmpresaService
